module.exports = __webpack_public_path__ + "static/info-circle.a82397d295605157a1425e94dcb12889.svg";